<link
	href="https://cdnjs.cloudflare.com/ajax/libs/video.js/7.8.1/video-js.min.css"
	rel="stylesheet"
>
<script
	src="https://cdnjs.cloudflare.com/ajax/libs/video.js/7.8.1/video.min.js"
></script>

<div class="page bg-white bg-desktop">
	<nav class="page-nav navbar navbar-expand navbar-dark d-none d-md-block">
		<div class="row">
			<div class="col-6 d-none d-md-block">
				<div class="logo negated logo-subareas"></div>
			</div>
			<div class="col-6 text-end d-none d-md-block">
				<div class="menulogo me-4 mt-4"></div>
			</div>
		</div>
	</nav>

	<div class="page-content p-0 pt-md-0 px-md-5 mb-md-6">
		<div class="card border-0 bg-white rounded-3">
			<div class="card-header border-0 pt-4 px-md-5 bg-white rounded-3">
				<div class="row">
					<div class="col-2">
						<app-back-button (clicked)="backToTraining()" />
					</div>

					<div class="col-8 text-center">
						<h2 class="my-1 text-primary text-uppercase d-none d-md-block">
							{{ TrainingExercise.Name }}
						</h2>
						<h3 class="my-1 text-primary text-uppercase d-md-none">
							{{ TrainingExercise.Name }}
						</h3>
					</div>

					<div class="col-2 text-end"></div>
				</div>
			</div>
			<div class="card-body ratio ratio-16x9">
				<video
					id="exercise-video"
					class="video-js"
					controls
					preload="auto"
					autoplay
					poster="{{ ImageUrl }}"
					data-bs-setup="{}"
				>
					<source src="{{ VideoUrl }}" type="video/mp4">
				</video>
			</div>
			<div class="card-body bg-primary rounded-3">
				<h5 class="card-title text-white mb-0 mt-3">
					{{ 'Training_Exercise_BodyRegion' | translate }}
				</h5>
				<p class="card-text text-white">{{ TrainingExercise.Bodyregion }}</p>

				<h5 class="card-title text-white mb-0">
					{{ 'Training_Exercise_Description' | translate }}
				</h5>
				<p class="card-text text-white">{{ TrainingExercise.Description }}</p>

				<div ng-hide="TrainingExercise.Progression.length === 0">
					<h5 class="card-title text-white mb-0">
						{{ 'Training_Exercise_Progression'| translate }}
					</h5>
					<p class="card-text text-white">{{ TrainingExercise.Progression }}</p>
				</div>
			</div>
			<div class="card-footer mx-auto py-3 bg-white border-0">
				<div class="menulogo logo-footer" routerLink="/healthprofil"></div>
			</div>
		</div>
	</div>
</div>
